import AccountSpecialPricing from './components/AccountSpecialPricing';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import get from 'lodash/get';
import {connect} from 'react-redux';

import { updateAgency } from '../../shared/redux/entities/actions'

import {
  ADJOY_DEFAULT_CHOOSE_COST,
  ADJOY_DEFAULT_THIS_OR_THAT_COST,
  ADJOY_DEFAULT_RATABLE_COST,
  ADJOY_DEFAULT_REVENUE_SPLIT,
  ADJOY_DEFAULT_QA_COST,
  ADJOY_DEFAULT_PUZZLE_COST
} from '../../config';

function mapStateToProps(state,props){
  const accountId = props.accountId;

  return {
    accountId:accountId,
    chooseDefaultCost:get(state,['entities','agencies',accountId,'chooseDefaultCost'],ADJOY_DEFAULT_CHOOSE_COST),
    qaDefaultCost:get(state,['entities','agencies',accountId,'qaDefaultCost'],ADJOY_DEFAULT_QA_COST),
    puzzleDefaultCost:get(state,['entities','agencies',accountId,'puzzleDefaultCost'],ADJOY_DEFAULT_PUZZLE_COST),
    ratableDefaultCost:get(state,['entities','agencies',accountId,'ratableDefaultCost'],ADJOY_DEFAULT_RATABLE_COST),
    defaultRevenueSplit:get(state,['entities','agencies',accountId,'defaultRevenueSplit'],ADJOY_DEFAULT_REVENUE_SPLIT),
    thisOrThatDefaultCost:get(state,['entities','agencies',accountId,'thisOrThatDefaultCost'],ADJOY_DEFAULT_THIS_OR_THAT_COST),
    defaultCostPerCompletion:get(state,['entities','agencies',accountId,'defaultCostPerCompletion'],0),
    useCostPerCompletion:get(state,['entities','agencies',accountId,'useCostPerCompletion'],false)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ updateAgency },dispatch);
}



export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountSpecialPricing));



// WEBPACK FOOTER //
// ./src/routes/AccountSpecialPricing/index.js